import * as Yup from "yup";

import { variables } from "../Variables";

const { required, IsEmail } = variables;

export const createWalletValidation = Yup.object({
  name: Yup.string().required(required),
  email: Yup.string().required(required).email(IsEmail),
  category: Yup.string().required(required),
  phone_Number: Yup.number().required(required),
  bvn: Yup.string().required(required),
  // is_default: Yup.bool.required(required),
});
